import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogContent,
    MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MediaViewerDialogModel } from '../../models/media-viewer-dialog-model';
import { MediaViewerWidgetComponent } from '../media-viewer-widget/media-viewer-widget.component';

@Component({
    selector: 'apcam-media-viewer-confirmation',
    templateUrl: './media-viewer-dialog.component.html',
    styleUrls: ['./media-viewer-dialog.component.scss'],
    imports: [MatDialogContent, MediaViewerWidgetComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaViewerDialogComponent {
    protected readonly data = inject<MediaViewerDialogModel>(MAT_DIALOG_DATA);
    protected readonly dialogRef = inject(
        MatDialogRef<MediaViewerDialogComponent>
    );
}
